import React from 'react';
import { Input, Form } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

class AbstractMachine {
  constructor(form, goTo) {
    this._form = form;
    this._goTo = goTo;
  }

  getName = () => {
    return this._name;
  };

  isSocialButtonsAllowed = () => {
    return true;
  };

  getTitle = () => {
    return (
      <FormattedMessage id="Login/Register" defaultMessage="Login/Register" />
    );
  };

  onChange = () => {};

  onSubmit = () => {
    console.log('AbstractMachine');
  };

  getMainInput(
    { userEmail = '', error, disabled = false, loginText = {} },
    ref = null
  ) {
    error =
      error && error.indexOf !== undefined && error.indexOf('mail') !== -1
        ? error
        : null;
    return (
      <Form.Item
        style={{ width: '100%' }}
        validateStatus={error ? 'error' : 'success'}
        help={
          error
            ? error.charAt(0).toUpperCase() + error.replace(/_/g, ' ').slice(1)
            : ''
        }
        name="userEmail"
        rules={[
          {
            required: true,
            message: loginText['Write your e-mail'],
          },
        ]}
        initialValue={userEmail}
      >
        <Input
          prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          placeholder={loginText['Enter your e-mail address']}
          ref={ref}
          disabled={disabled}
          onChange={(e) => this.onChange(e)}
          onPressEnter={this.onSubmit}
        />
      </Form.Item>
    );
  }

  getSecondaryInput({ disabled = false, loginText = {} }, ref = null) {
    const compareToFirstEmail = () => (rule, value) => {
      if (value && value !== this._form.getFieldValue('userEmail')) {
        return Promise.reject(loginText['E-mail addresses do not match']);
      }
      return Promise.resolve();
    };

    const validator = compareToFirstEmail();

    return (
      <Form.Item
        style={{ width: '100%' }}
        name="userEmailConfirm"
        rules={[
          {
            required: true,
            message: loginText['Confirm your e-mail'],
          },
          { validator },
        ]}
      >
        <Input
          prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          placeholder={loginText['Confirm e-mail address']}
          ref={ref}
          disabled={disabled}
          // onChange={(e) => this.onChange(e)}
          // onPressEnter={this.onSubmit}
        />
      </Form.Item>
    );
  }

  isShowFreePro = () => {
    return true;
  };

  render() {}
}

export default AbstractMachine;
